module.exports = __webpack_public_path__ + "img/buypower-logo.0f1c46ce.png";